import { Controller } from '@hotwired/stimulus'
import $ from "jquery"
import { FetchRequest } from '@rails/request.js'
import select2 from 'select2'

export default class extends Controller {
  static targets = [
    "ErrorsList", "ZipcodeInput", "NameInput", "SpeciesInput", "VarietyInputContainer", "VarietyInput",
    "ListingsSelect",
    "FlatbedDeliveryInput", "DryVanDeliveryInput", "HopperDeliveryInput", "AnyDeliveryInput",
    "UnloadingOptionsContainer",  "UnloadingOptionCheckboxLoadingDock", "UnloadingOptionCheckboxForklift", "UnloadingOptionCheckboxPalletJack", "UnloadingOptionCheckboxNone",
    "ManualOriginContainer"
  ]

  connect() {
    this.userUnloadingOptionsSelected = ["none"]
    this.listingsData = JSON.parse(this.ListingsSelectTarget.dataset.initialListingData)
    this.destinationZipcode = this.element.dataset.destinationZipcode

    $(this.SpeciesInputTarget).on('select2:select', (e) => {
      this.onSpeciesChange()
    })

    $(this.ListingsSelectTarget).on('change', (e) => {
      this.onListingsSelectChange(e)
    })

    select2($)

    setTimeout(() => {
      this.selectedListingIds = $(this.ListingsSelectTarget).select2('data').map((option) => option.id)
      this.initMap()
    }, 250)
  }

  initMap() {
    this.mapMarkers = []
    this.geocoder = new google.maps.Geocoder()
    this.map = new google.maps.Map(document.getElementById("map"), {
      center: { lat: 41.215, lng: -96.112 },
      zoom: 4,
      fullscreenControl: false
    });
    this.mapIw = new google.maps.InfoWindow()
    this.oms = new OverlappingMarkerSpiderfier(this.map, {
      markersWontMove: true,
      markersWontHide: true,
      basicFormatEvents: true,
      keepSpiderfied: true
    });
    this.addCustomerMarker()
    this.listingsData.map((listing) => this.addMapMarkerForListing(listing))
  }

  clearMapMarkers() {
    this.mapMarkers.map((listingMarker) => this.oms.removeMarker(listingMarker.marker))
    this.mapMarkers = []
  }

  clearCustomerMarker() {
    if (this.customerMarker) {
      this.oms.removeMarker(this.customerMarker)
    }
  }

  async addCustomerMarker() {
    this.customerMarker = null

    if (this.destinationZipcode) {
      let response = await this.geocoder.geocode({ 'address': this.destinationZipcode })
      let result = response.results[0]
      let location = result.geometry.location
      var marker = new google.maps.Marker({ position: { lat: location.lat(), lng: location.lng() }, icon: { url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png', scaledSize: new google.maps.Size(40, 40) }, optimized: true })
      this.customerMarker = marker
      google.maps.event.addListener(marker, 'spider_click', (e) => {
        this.mapIw.setContent("<div class='mb-2 text-lg font-semibold'>Customer:</div><p>"+result.formatted_address+"</p>")
        this.mapIw.open(this.map, marker)
      })
      this.oms.addMarker(this.customerMarker)
      this.fitMapToMarkerBounds()
    }
  }

  async addMapMarkerForListing(listing) {
    let response = await this.geocoder.geocode({ 'address': listing.zipcode })
    let result = response.results[0]
    let location = result.geometry.location
    let icon_url = ""
    let selected = this.selectedListingIds.includes(listing.id.toString())
    if (selected) {
      icon_url = 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'
    } else {
      icon_url = 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
    }
    var marker = new google.maps.Marker({ position: { lat: location.lat(), lng: location.lng() }, icon: { url: icon_url, scaledSize: new google.maps.Size(40, 40) }, optimized: true })
    this.mapMarkers.push({ id: listing.id, marker: marker })
    google.maps.event.addListener(marker, 'spider_click', (e) => {
      let markerContent = "<div class='mb-2 text-lg font-semibold'>Listing:</div><p class='mb-1 text-md font-medium'>" + listing.cms_title + "</p><p class='mb-1'>" + result.formatted_address + "</p>"
      if (!selected) {
        markerContent += "<a href='#' class='text-blue-500 font-medium' data-action='click->truckload-order-form#onMapListingClick' data-listing-id='"+listing.id+"'>Select Listing</a>"
      }
      this.mapIw.setContent(markerContent)
      this.mapIw.open(this.map, marker)
    })
    this.oms.addMarker(marker)
    this.fitMapToMarkerBounds()
  }

  fitMapToMarkerBounds() {
    var bounds = new google.maps.LatLngBounds();
    this.mapMarkers.map((listingMarker) => bounds.extend({ lat: listingMarker.marker.position.lat(), lng: listingMarker.marker.position.lng() }))
    this.map.fitBounds(bounds);
  }

  redrawMapMarkers() {
    this.clearMapMarkers()
    this.listingsData.map((listing) => this.addMapMarkerForListing(listing))
  }

  hopperDeliveryOnlyChecked() {
    return this.HopperDeliveryInputTarget.checked == true && this.FlatbedDeliveryInputTarget.checked == false && this.DryVanDeliveryInputTarget.checked == false
  }

  hideUnloadingOptions() {
    this.UnloadingOptionsContainerTarget.classList.add("hidden")
    this.UnloadingOptionCheckboxLoadingDockTarget.checked = false
    this.UnloadingOptionCheckboxForkliftTarget.checked = false
    this.UnloadingOptionCheckboxPalletJackTarget.checked = false
    this.UnloadingOptionCheckboxNoneTarget.checked = true
  }

  showUnloadingOptions() {
    this.UnloadingOptionsContainerTarget.classList.remove("hidden")
    if (this.userUnloadingOptionsSelected.includes("dock")) {
      this.UnloadingOptionCheckboxLoadingDockTarget.checked = true
    }
    if (this.userUnloadingOptionsSelected.includes("forklift")) {
      this.UnloadingOptionCheckboxForkliftTarget.checked = true
    }
    if (this.userUnloadingOptionsSelected.includes("pallet_jack")) {
      this.UnloadingOptionCheckboxPalletJackTarget.checked = true
    }
    if (this.userUnloadingOptionsSelected.includes("none")) {
      this.UnloadingOptionCheckboxNoneTarget.checked = true
    } else {
      this.UnloadingOptionCheckboxNoneTarget.checked = false
    }
  }

  setUnloadingOptionNoneWhenEmpty() {
    if (this.UnloadingOptionCheckboxLoadingDockTarget.checked == false && this.UnloadingOptionCheckboxForkliftTarget.checked == false && this.UnloadingOptionCheckboxPalletJackTarget.checked == false) {
      this.UnloadingOptionCheckboxNoneTarget.checked = true
      this.userUnloadingOptionsSelected.push("none")
    }
  }

  onDestinationZipcodeChange(e) {
    this.destinationZipcode = e.target.value
    this.clearCustomerMarker()
    this.addCustomerMarker()
  }

  onSpeciesChange() {
    var selectedOption = this.SpeciesInputTarget.options[this.SpeciesInputTarget.selectedIndex];
    var productId = selectedOption.value
    this.loadListingsForProduct(productId)
  }

  async loadListingsForProduct(productId) {
    this.clearMapMarkers()
    this.listingsData = []

    const request = new FetchRequest('get', `/admin/products/${productId}/truckload_listings`)
    const response = await request.perform()

    if (response.ok) {
      const body = await response.text
      const listings = JSON.parse(body)

      $(this.ListingsSelectTarget).val(null).trigger('change')
      $(this.ListingsSelectTarget).empty()

      listings.map((listing) => {
        let newOption = new Option(listing.cms_title, listing.id, false, false)
        $(this.ListingsSelectTarget).append(newOption)
        this.addMapMarkerForListing(listing)
        this.listingsData.push(listing)
      })

      $(this.ListingsSelectTarget).trigger('change')
    }
  }

  onVarietyChange(e) {
    var value = e.target.dataset.value

    if (value !== "VNS") {
      this.VarietyInputTarget.value = ""
      this.VarietyInputContainerTarget.classList.remove("hidden")
    } else {
      this.VarietyInputContainerTarget.classList.add("hidden")
      this.VarietyInputTarget.value = "VNS"
    }
  }

  onMapListingClick(e) {
    e.preventDefault()

    let listingId = e.target.dataset.listingId
    let select2Values = $(this.ListingsSelectTarget).select2('data').map((option) => option.id)
    select2Values.push(listingId)
    $(this.ListingsSelectTarget).val(select2Values)
    $(this.ListingsSelectTarget).trigger('change')
    this.mapIw.close()
  }

  onListingsSelectChange(e) {
    this.selectedListingIds = $(this.ListingsSelectTarget).select2('data').map((option) => option.id)
    this.redrawMapMarkers()
  }

  onPackagingTypeChange(e) {
    if (e.target.value == "Bulk") {
      this.FlatbedDeliveryInputTarget.checked = false
      this.DryVanDeliveryInputTarget.checked = false
      this.HopperDeliveryInputTarget.checked = true
      this.AnyDeliveryInputTarget.checked = false
      this.hideUnloadingOptions()
    } else if (e.target.value == "Either") {
      this.FlatbedDeliveryInputTarget.checked = true
      this.DryVanDeliveryInputTarget.checked = true
      this.HopperDeliveryInputTarget.checked = true
      this.AnyDeliveryInputTarget.checked = false
      this.showUnloadingOptions()
    } else if (e.target.value == "Totes") {
      this.FlatbedDeliveryInputTarget.checked = true
      this.DryVanDeliveryInputTarget.checked = true
      this.HopperDeliveryInputTarget.checked = false
      this.AnyDeliveryInputTarget.checked = false
      this.showUnloadingOptions()
    }
  }

  onUnloadingOptionDockChange(e) {
    if (e.target.checked) {
      this.userUnloadingOptionsSelected.push("dock")
      this.UnloadingOptionCheckboxNoneTarget.checked = false
      this.userUnloadingOptionsSelected = this.userUnloadingOptionsSelected.filter(opt => opt !== "none")
    } else {
      this.userUnloadingOptionsSelected = this.userUnloadingOptionsSelected.filter(opt => opt !== "dock")
      this.setUnloadingOptionNoneWhenEmpty()
    }
  }

  onUnloadingOptionForkliftChange(e) {
    if (e.target.checked) {
      this.userUnloadingOptionsSelected.push("forklift")
      this.UnloadingOptionCheckboxNoneTarget.checked = false
      this.userUnloadingOptionsSelected = this.userUnloadingOptionsSelected.filter(opt => opt !== "none")
    } else {
      this.userUnloadingOptionsSelected = this.userUnloadingOptionsSelected.filter(opt => opt !== "forklift")
      this.setUnloadingOptionNoneWhenEmpty()
    }
  }

  onUnloadingOptionPalletJackChange(e) {
    if (e.target.checked) {
      this.userUnloadingOptionsSelected.push("pallet_jack")
      this.UnloadingOptionCheckboxNoneTarget.checked = false
      this.userUnloadingOptionsSelected = this.userUnloadingOptionsSelected.filter(opt => opt !== "none")
    } else {
      this.userUnloadingOptionsSelected = this.userUnloadingOptionsSelected.filter(opt => opt !== "pallet_jack")
      this.setUnloadingOptionNoneWhenEmpty()
    }
  }

  onUnloadingOptionNoneChange(e) {
    if (e.target.checked) {
      this.userUnloadingOptionsSelected.push("none")
    } else {
      this.userUnloadingOptionsSelected = this.userUnloadingOptionsSelected.filter(opt => opt !== "none")
    }
  }

  onTruckTypeChange(e) {
    if (e.target.id == "truck_types_hopper" && this.hopperDeliveryOnlyChecked()) {
      this.hideUnloadingOptions()
    } else {
      this.showUnloadingOptions()
    }
  }

  onManualOrigin(e) {
    e.preventDefault()

    this.ManualOriginContainerTarget.classList.remove("hidden")
    e.target.classList.add("hidden")
  }

  onSubmit(e) {
    e.stopPropagation()
    e.preventDefault()

    e.target.form.checkValidity()

    if (e.target.form.reportValidity()) {
      var formData = new FormData(e.target.form)

      fetch(e.target.form.action, {
        method: "POST",
        headers: {
        },
        body: formData
      })
        .then(response => response.json())
        .then(response => {
          if (response.success) {
            window.location = response.location
            return
          }

          if (response.errors) {
            if (response.errors.destination_zipcode) {
              this.ZipcodeInputTarget.classList.add("border-red-400")
            } else {
              this.ZipcodeInputTarget.classList.remove("border-red-400")
            }

            if (response.errors.name) {
              this.NameInputTarget.classList.add("border-red-400")
            } else {
              this.NameInputTarget.classList.remove("border-red-400")
            }

            if (response.errors.listing_ids) {
              this.ListingsSelectTarget.classList.add("border-red-400")
            } else {
              this.ListingsSelectTarget.classList.remove("border-red-400")
            }

            this.ErrorsListTarget.innerHTML = response.full_error_messages.join(", ")
            this.ErrorsListTarget.classList.remove("hidden")
          }
        })
        .catch(console.error)
    }
  }
}